@if (documentSections?.length) {
  <section class="card mb-4" [ngClass]="borderClass">
    <div class="card-body">
      <h2 class="mb-4">{{ 'ATTACHMENTS.TITLE' | translate }}</h2>
      @if (attachmentsInfo) {
        <div class="alert alert-warning mb-4">
          {{ attachmentsInfo | translate }}
        </div>
      }
      @for (
        documentSection of documentSections;
        let last = $last;
        track documentSection.id
      ) {
        <section>
          @let shouldShowFileInputInvalidMessage =
            this.shouldShowFileInputInvalidMessage(documentSection);
          <div
            class="card"
            [ngClass]="[
              shouldShowFileInputInvalidMessage ? 'border-danger border-2' : '',
              !shouldShowFileInputInvalidMessage ? borderClass : '',
              !last ? 'mb-4' : '',
            ]"
          >
            <div class="card-header" [ngClass]="backgroundClass">
              {{ documentSection.name | translate }}
            </div>
            <div
              class="card-body"
              [ngClass]="{
                required:
                  documentSection.isObligatory &&
                  documentSection.alternativeDocumentTypes?.length,
              }"
            >
              @if (
                documentSection.stampDuty?.isPaymentEnabled &&
                (documentSection.stampDuty?.isInitialPaid ||
                  (isStampDutyPaidInCurrentSession(documentSection.id) | async))
              ) {
                <div class="alert alert-success m-0">
                  <i class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ 'ATTACHMENTS.PAID' | translate }}
                </div>
              } @else if (
                documentSection.stampDuty?.isPaymentEnabled &&
                (documentSection.stampDuty?.isInitialPending ||
                  (stampDutyService.isPendingInCurrentSession(
                    portalId,
                    documentSection.id
                  ) | async))
              ) {
                <button
                  class="btn btn-outline-primary"
                  [disabled]="true"
                  [attr.aria-label]="
                    'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate
                  "
                  [attr.title]="'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate"
                >
                  <i class="fa fa-spinner fa-pulse fa-fw"></i>
                  {{ 'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate }}
                </button>
              } @else {
                @if (
                  documentSection.uploadAvailable &&
                  !documentSection.alternativeDocumentTypes?.length
                ) {
                  <gk-file-input
                    class="mb-2 bg-color-from-db-for-button-child"
                    [ngClass]="{ required: documentSection.isObligatory }"
                    [attr.aria-required]="documentSection.isObligatory"
                    [showPreviews]="true"
                    (filesChange)="
                      handleFileInputAction(documentSection.id, $event)
                    "
                  >
                  </gk-file-input>
                }

                @if (
                  documentSection.uploadAvailable &&
                  documentSection.alternativeDocumentTypes?.length
                ) {
                  @for (
                    alternativeDocumentType of documentSection.alternativeDocumentTypes;
                    let last = $last;
                    track alternativeDocumentType.id
                  ) {
                    <div
                      class="alternative-document-type"
                      [ngClass]="{
                        'mb-2': !last,
                      }"
                    >
                      <span>{{
                        alternativeDocumentType.name | translate
                      }}</span>
                      @if (
                        alternativeDocumentType.stampDuty?.isPaymentEnabled &&
                        (alternativeDocumentType.stampDuty?.isInitialPaid ||
                          (isStampDutyPaidInCurrentSession(
                            alternativeDocumentType.id
                          ) | async))
                      ) {
                        <div class="alert alert-success m-0">
                          <i class="fa fa-check-circle" aria-hidden="true"></i>
                          {{ 'ATTACHMENTS.PAID' | translate }}
                        </div>
                      } @else if (
                        alternativeDocumentType.stampDuty?.isPaymentEnabled &&
                        (alternativeDocumentType.stampDuty?.isInitialPending ||
                          (stampDutyService.isPendingInCurrentSession(
                            portalId,
                            alternativeDocumentType.id
                          ) | async))
                      ) {
                        <div class="mt-1">
                          <button
                            class="btn btn-outline-primary"
                            [disabled]="true"
                            [attr.aria-label]="
                              'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate
                            "
                            [attr.title]="
                              'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate
                            "
                          >
                            <i class="fa fa-spinner fa-pulse fa-fw"></i>
                            {{ 'ATTACHMENTS.PAYMENT_IN_PROGRESS' | translate }}
                          </button>
                        </div>
                      } @else {
                        <gk-file-input
                          class="mb-2 bg-color-from-db-for-button-child"
                          [showPreviews]="true"
                          (filesChange)="
                            handleFileInputAction(
                              alternativeDocumentType.id,
                              $event
                            )
                          "
                        ></gk-file-input>
                        @if (
                          alternativeDocumentType.stampDuty?.isPaymentEnabled &&
                          !isChosenDocument(alternativeDocumentType.id)
                        ) {
                          <gk-payment-button
                            [documentSectionId]="alternativeDocumentType.id"
                            [portalId]="portalId"
                            [buttonClass]="
                              'btn btn-outline-primary mt-2 me-1 bg-white-not-important'
                            "
                            [buttonIconVisible]="true"
                            [paymentInfoTooltipVisible]="false"
                            [paymentWithoutCheckingLimit]="true"
                            [paymentOwnerRequired]="true"
                            [paymentInNewTab]="true"
                            [paymentAmountType]="
                              alternativeDocumentType.stampDuty?.amountType
                            "
                            [paymentEndSimpleInfo]="true"
                            [abortPendingStatusOnRedirect]="true"
                            (isPaymentBeginCalled)="
                              triggerStampDutyPaymentStatusCheck(
                                alternativeDocumentType.id
                              )
                            "
                          ></gk-payment-button>
                        }
                      }
                    </div>
                  }
                }
                @if (documentSection.sampleDocuments?.length) {
                  @for (
                    sampleDocument of documentSection.sampleDocuments;
                    track sampleDocument.id
                  ) {
                    <button
                      type="button"
                      class="btn btn-outline-color-from-db mt-2 me-1"
                      (click)="downloadSampleDocument(sampleDocument.id)"
                    >
                      <i class="fa fa-download"></i>
                      <span class="ms-1">{{ sampleDocument.displayName }}</span>
                    </button>
                  }
                }
                @if (
                  documentSection.stampDuty?.isPaymentEnabled &&
                  !isChosenDocument(documentSection.id)
                ) {
                  <gk-payment-button
                    [documentSectionId]="documentSection.id"
                    [portalId]="portalId"
                    [buttonClass]="'btn btn-outline-primary mt-2 me-1'"
                    [buttonIconVisible]="true"
                    [paymentInfoTooltipVisible]="false"
                    [paymentWithoutCheckingLimit]="true"
                    [paymentOwnerRequired]="true"
                    [paymentInNewTab]="true"
                    [paymentAmountType]="documentSection.stampDuty?.amountType"
                    [paymentEndSimpleInfo]="true"
                    [abortPendingStatusOnRedirect]="true"
                    (isPaymentBeginCalled)="
                      triggerStampDutyPaymentStatusCheck(documentSection.id)
                    "
                  ></gk-payment-button>
                }
              }
            </div>

            @if (documentSection.alternativeDocumentTypes?.length) {
              <div class="card-footer">
                <div
                  class="my-2"
                  [ngClass]="
                    shouldShowFileInputInvalidMessage
                      ? 'alert alert-danger'
                      : 'text-danger'
                  "
                >
                  {{
                    'ATTACHMENTS.AT_LEAST_ONE_ATTACHMENT_REQUIRED' | translate
                  }}
                </div>
              </div>
            } @else if (shouldShowFileInputInvalidMessage) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'ATTACHMENTS.NO_FILE_CHOSEN' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      }
    </div>
  </section>
}
